package one.healthium.insights.domain.models

data class TipModel(
    val id: String,
    val title: String,
    val text: String,
)
